import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    uid: "",
    email: "",
    verified: null,
    phoneNumber: ""
};

export const authstateSlice = createSlice({
    name: 'authstate',
    initialState,
    reducers: {
        storeAuthstate: (state, action) => {
            state.uid = action.payload.uid;
            state.email = action.payload.email;
            state.verified = action.payload.verified;
            state.phoneNumber = action.payload.phoneNumber;
        },
        resetAuthstate: state => initialState
    }
});

export const {storeAuthstate, resetAuthstate} = authstateSlice.actions;

export const selectAuthstate = state => state.authstate;
export const selectUid = state => state.authstate.uid;
export const selectEmail = state => state.authstate.email;

export default authstateSlice.reducer;
